import { __generator } from "tslib";
import { call, all, takeLatest, put, select, takeEvery, delay, } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request } from '../../xhr';
import { blockUser, blockUserAndRedirect, unblockUser, blockUserSuccess, blockUserFail, unblockUserSuccess, unblockUserFail, searchFriendsWithOptions, fetchMoreFriends, initializeFriendList, } from './actionCreators';
import ErrorIcon from '../../Icons/24x24/Error';
import { getUserById } from './selectors';
import { addNotification } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications';
import { selectors as streamSelectors, withOffset } from '../../Stream';
import { normalize } from 'normalizr';
import { userListSchema } from '../normalizr/schemas/user';
import { friendsStreamId } from './constants';
var logger = ddt.createLogger('usersaga');
export function doBlockUser(userIdOrUuid, chatroomId) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/user/block',
                    data: {
                        userid: userIdOrUuid,
                        chatroom_id: chatroomId,
                    },
                }, function () { return ({ success: true }); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function blockUserSaga(action) {
    var userIdOrUuid, result, userId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to block invalid userId', action);
                    return [2 /*return*/];
                }
                userIdOrUuid = action.payload;
                return [4 /*yield*/, call(doBlockUser, userIdOrUuid)];
            case 1:
                result = _a.sent();
                userId = result && result.userid;
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(blockUserSuccess(userId))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(blockUserFail(userId, result))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function blockUserAndRedirectSaga(action) {
    var _a, userIdOrUuid, redirectLocation, result, userId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to block invalid userId', action);
                    return [2 /*return*/];
                }
                _a = action.payload, userIdOrUuid = _a.userId, redirectLocation = _a.redirectLocation;
                return [4 /*yield*/, call(doBlockUser, userIdOrUuid)];
            case 1:
                result = _b.sent();
                userId = result && result.userid;
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(blockUserSuccess(userId))];
            case 2:
                _b.sent();
                window.location.href = redirectLocation;
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, call(handleBlockUserFail, userIdOrUuid, result)];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function unblockUserSaga(action) {
    var userId, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    logger.error('Tried to unblock invalid userId', action);
                    return [2 /*return*/];
                }
                userId = action.payload;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/unblock',
                        data: {
                            userid: userId,
                        },
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _a.sent();
                if (!(result && result.success)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(unblockUserSuccess(userId))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(unblockUserFail(userId, result))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function handleBlockUserSuccess() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(addNotification(NotificationType.Generic, {
                    messageLocaleKey: 'common.notification.blockUser.success',
                }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleBlockUserFail(userId, result) {
    var user, key;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(getUserById, userId)];
            case 1:
                user = _d.sent();
                key = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.errorDetails) === null || _a === void 0 ? void 0 : _a.reason) === null || _b === void 0 ? void 0 : _b.toLowerCase()) !== null && _c !== void 0 ? _c : 'default';
                return [4 /*yield*/, put(addNotification(NotificationType.Generic, {
                        messageLocaleKey: "common.notification.blockUser.fail." + key,
                        messageLocaleOptions: { username: user.username },
                        isError: true,
                        cardProps: {
                            iconComponent: ErrorIcon,
                            multiLine: true,
                            limitTextWidth: false,
                            duration: 5000,
                        },
                    }))];
            case 2:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
function handleSearchFriends(_a) {
    var searchQuery, params, result, found;
    var _b = _a.payload, query = _b.query, callback = _b.callback, _c = _b.isChatContext, isChatContext = _c === void 0 ? false : _c, includeNonFriendExactMatch = _b.includeNonFriendExactMatch, userType = _b.userType;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: 
            // debounce for fast typing
            return [4 /*yield*/, delay(300)];
            case 1:
                // debounce for fast typing
                _d.sent();
                searchQuery = query.trim().toLowerCase();
                if (searchQuery.length < 3) {
                    callback([]);
                    return [2 /*return*/];
                }
                params = {
                    search: includeNonFriendExactMatch ? searchQuery : undefined,
                    letter: searchQuery[0],
                    page: 0,
                    is_chat: isChatContext,
                    user_type: userType,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: "/user/friendsforletter",
                        params: params,
                    }, function () {
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line global-require
                            var users = require('@wix/da-sample-data').users;
                            return { users: users };
                        }
                    })];
            case 2:
                result = _d.sent();
                if (!result || !result.users || result.users.length === 0) {
                    return [2 /*return*/];
                }
                found = result.users
                    // include only those usernames that actually start with query
                    .filter(function (u) { return u.username.toLowerCase().startsWith(searchQuery); })
                    // unique
                    .filter(function (u, idx, self) { return self.findIndex(function (u2) { return u.userId === u2.userId; }) === idx; });
                callback(found);
                return [2 /*return*/];
        }
    });
}
function handleFetchMoreFriends(_a) {
    var _b, offset, limit, params, result, _c, entities, items;
    var _d;
    var streamId = _a.payload.streamId;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, select(function (state) { return ({
                    offset: withOffset.selectors.getNextOffset(state, streamId),
                    limit: streamSelectors.getItemsPerFetch(state, streamId),
                }); })];
            case 1:
                _b = _e.sent(), offset = _b.offset, limit = _b.limit;
                params = {
                    user_type: 'deviant',
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: '/user/friends',
                        params: params,
                    }, function () {
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line global-require
                            var users = require('@wix/da-sample-data').users;
                            return { results: users, hasMore: false };
                        }
                    })];
            case 2:
                result = _e.sent();
                if (!!result) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({ streamId: streamId, errorMsg: 'fetch error' }))];
            case 3:
                _e.sent();
                return [2 /*return*/];
            case 4:
                _c = normalize((_d = result.results) !== null && _d !== void 0 ? _d : [], userListSchema), entities = _c.entities, items = _c.result;
                return [4 /*yield*/, put(withOffset.actions.fetchSuccess({
                        streamId: streamId,
                        items: items,
                        entities: entities,
                        hasMore: result.hasMore || false,
                    }))];
            case 5:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
function initFriendList() {
    var isAlreadyInit;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(streamSelectors.isInitialized, friendsStreamId)];
            case 1:
                isAlreadyInit = _a.sent();
                if (isAlreadyInit) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withOffset.actions.initialize({
                        streamId: friendsStreamId,
                        itemsPerFetch: 50,
                        hasMore: true,
                        fetchNextCallback: fetchMoreFriends,
                    }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(blockUser, blockUserSaga),
                    takeLatest(unblockUser, unblockUserSaga),
                    takeLatest(blockUserAndRedirect, blockUserAndRedirectSaga),
                    takeLatest(blockUserSuccess, handleBlockUserSuccess),
                    takeLatest(searchFriendsWithOptions, handleSearchFriends),
                    takeEvery(fetchMoreFriends, handleFetchMoreFriends),
                    takeEvery(initializeFriendList, initFriendList),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map